import { faImage } from '@fortawesome/pro-regular-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ISelectOption } from '@feathr/components';
import { Icon, Select } from '@feathr/components';
import { useLicense } from '@feathr/extender/hooks';

import { getOptions } from './CreativesClassSelect.utils';
import type { ICreativesFilters } from './EventCreativesPage';

import * as styles from './CreativesClassSelect.css';

interface IProps {
  filters: ICreativesFilters;
  setFilters: (filters: ICreativesFilters) => void;
}

function TypeSelectLabel({ name }: ISelectOption): JSX.Element {
  return (
    <>
      <Icon icon={faImage} /> {name}
    </>
  );
}

function CreativesClassSelect({ filters, setFilters }: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();
  const hasFacebook = useLicense('facebook');
  const options = getOptions(hasFacebook);

  return (
    <Select
      filterOption={({ label }, inputValue): string => {
        return label.toLowerCase().includes(inputValue.toLowerCase());
      }}
      formatOptionLabel={TypeSelectLabel}
      isClearable={true}
      name={'creative-type'}
      onClear={(): void =>
        setFilters({
          ...filters,
          spec: undefined,
        })
      }
      onSelectSingle={({ id }): void => {
        setFilters({
          ...filters,
          spec: id,
        });
      }}
      options={options}
      placeholder={t('Type')}
      value={options.find((option) => {
        return option.id === filters.spec;
      })}
      wrapperClassName={styles.filter}
    />
  );
}

export default CreativesClassSelect;
